import { STATUS_TYPE } from '../../../enum';


export interface NetworkLandingPageVideoResponse {
  status: string;
  message: string;
  data: NetworkLandingPageVideoItem[];
}

export interface NetworkLandingPageVideoItem {
  id: number;
  title: string;
  description: string;
  position: number;
  type: string;
  link: string;
  created_at: string;
  updated_at: string;
  user_id: number;
  filename: string;
  thumb_name: string;
  thumb_link: string;
}



interface InitialState {
  overview?: NetworkLandingPageVideoItem;
  data: NetworkLandingPageVideoItem[];
  searchText: string,
  status: STATUS_TYPE;
  isError: boolean;
  isLoading: boolean;
  isSuccess: boolean;
  errorMessage: string;
}


export const initialState: InitialState = {
  overview: undefined,
  data: [],
  searchText: '',
  status: 'idle',
  isError: false,
  isLoading: false,
  isSuccess: false,
  errorMessage: '',
};
